import gql from "graphql-tag";

export const LOAD_COLORS = gql`
    query getColors($params: FindByFilterParamsInput) {
        xopsColorService_findByFilter(params: $params) {
            results { name id colorValue }
        }
    }
`;